"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fixStringField = exports.fixDateTimeField = exports.fixDateField = void 0;
var capitalize_1 = require("../methods/capitalize");
/**
 * naprawia wartośc w polu date
 *
 * @export
 * @param {*} parent obiekt nadrzędny
 * @param {(string | number)} key nazwa pola
 * @param {*} [Vue] konstruktor Vue
 * @returns {boolean} czy naprawiono
 */
function fixDateField(parent, key, Vue) {
    var value = parent[key];
    var changed = false;
    if (value && value.length > 10) {
        value = value.substr(0, 10);
        changed = true;
    }
    if (changed) {
        if (Vue) {
            Vue.set(parent, key, value);
        }
        else {
            parent[key] = value;
        }
    }
    return changed;
}
exports.fixDateField = fixDateField;
/**
 * naprawia wartośc w polu date-time
 *
 * @export
 * @param {*} parent obiekt nadrzędny
 * @param {(string | number)} key klucz pola
 * @param {*} [Vue] konstruktor Vue
 * @returns {boolean} czy naprawiono
 */
function fixDateTimeField(parent, key, Vue) {
    var value = parent[key];
    var changed = false;
    if (value) {
        if (value.indexOf('T') === 10) {
            value = value.replace('T', ' ');
            changed = true;
        }
        if (value.length < 19) {
            if (value.length >= 10) {
                value = value.substr(0, 10) + ' 00:00:00';
                changed = true;
            }
        }
    }
    if (changed) {
        if (Vue) {
            Vue.set(parent, key, value);
        }
        else {
            parent[key] = value;
        }
    }
    return changed;
}
exports.fixDateTimeField = fixDateTimeField;
/**
 * naprawia wartośc w polu string
 *
 * @export
 * @param {*} parent obiekt nadrzędny
 * @param {(string | number)} key klucz pola
 * @param {string} format format pola
 * @param {*} [Vue] konstruktor Vue
 * @returns {boolean} czy naprawiono
 */
function fixStringField(parent, key, format, Vue) {
    var value = parent[key];
    if (value) {
        var nvalue = value;
        switch (format) {
            case 'uppercase':
                nvalue = value.toLocaleUpperCase();
                break;
            case 'lowercase':
                nvalue = value.toLocaleLowerCase();
                break;
            case 'capitalize':
                nvalue = (0, capitalize_1.default)(value);
                break;
        }
        if (value !== nvalue) {
            if (Vue) {
                Vue.set(parent, key, nvalue);
            }
            else {
                parent[key] = nvalue;
            }
            return true;
        }
    }
    return false;
}
exports.fixStringField = fixStringField;
/**
 * Naprawia formaty danych typu date i date-time
 *
 * @export
 * @param {JSONSchema} schema schemat
 * @param {*} data dane
 * @param {*} [Vue] konstruktor Vue
 * @returns {number} ile pól naprawino
 */
function fixDateFormat(schema, data, Vue) {
    var result = 0;
    if (schema.type === 'object') {
        var props = schema.properties;
        for (var key in schema.properties) {
            if (props.hasOwnProperty(key)) {
                var pschema = props[key];
                switch (pschema.type) {
                    case 'object':
                    case 'array':
                        fixDateFormat(pschema, data[key], Vue);
                    case 'string':
                        switch (pschema.format) {
                            case 'date-time':
                                result += fixDateTimeField(data, key, Vue) ? 1 : 0;
                                break;
                            case 'date':
                                result += fixDateField(data, key, Vue) ? 1 : 0;
                                break;
                            case 'uppercase':
                            case 'lowercase':
                            case 'capitalize':
                                result += fixStringField(data, key, pschema.format, Vue) ? 1 : 0;
                                break;
                        }
                }
            }
        }
    }
    else if (schema.type === 'array') {
        var pschema = schema.items;
        for (var i = 0; i < data.length; i++) {
            switch (pschema.type) {
                case 'object':
                case 'array':
                    result += fixDateFormat(pschema, data[i], Vue);
                case 'string':
                    switch (pschema.format) {
                        case 'date-time':
                            result += fixDateTimeField(data, i, Vue) ? 1 : 0;
                            break;
                        case 'date':
                            result += fixDateField(data, i, Vue) ? 1 : 0;
                            break;
                        case 'uppercase':
                        case 'lowercase':
                        case 'capitalize':
                            result += fixStringField(data, i, pschema.format, Vue) ? 1 : 0;
                            break;
                    }
            }
        }
    }
    return result;
}
exports.default = fixDateFormat;
//# sourceMappingURL=fixDateFormat.js.map